import type {
  ChangePasswordInput,
  ForgotPasswordInput,
  LoginInput,
  MeDTO,
  PublicContextDTO,
  ResetPasswordInput,
  UpdateProfileInput,
} from '@lightbm/shared';
import { api } from '@/lib/api-client';

export const authApi = {
  me: () => api.get<MeDTO>('/auth/me'),
  login: (input: LoginInput) => api.post<MeDTO>('/auth/login', input),
  logout: () => api.post<void>('/auth/logout'),
  updateProfile: (input: UpdateProfileInput) => api.patch<MeDTO>('/auth/me', input),
  changePassword: (input: ChangePasswordInput) => api.post<MeDTO>('/auth/change-password', input),
  forgotPassword: (input: ForgotPasswordInput) =>
    api.post<{ ok: boolean }>('/auth/forgot-password', input),
  resetPassword: (input: ResetPasswordInput) => api.post<void>('/auth/reset-password', input),
  publicContext: () => api.get<PublicContextDTO>('/app/public'),
};
